export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Public-facing API base URL shown in landing page / docs code snippets.
// Always a real public URL (dev → sciencetoken-dev-api, prod → sciencetoken-api).
// Distinct from VITE_API_BASE_URL, which may be "localhost:8080" in dev for the proxy.
export const API_PUBLIC_BASE_URL = (
  (import.meta.env.VITE_PUBLIC_API_BASE_URL as string | undefined) ||
  "https://api.dev.sciencetoken.ai"
).replace(/\/+$/, "");

export const ANTHROPIC_PROXY_URL = `${API_PUBLIC_BASE_URL}/proxy/anthropic`;
export const OPENAI_PROXY_URL = `${API_PUBLIC_BASE_URL}/proxy/openai`;

// Generate login URL at runtime so redirect URI reflects the current origin.
export const getLoginUrl = () => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  const redirectUri = `${window.location.origin}/api/oauth/callback`;
  const state = btoa(redirectUri);

  const url = new URL(`${oauthPortalUrl}/app-auth`);
  url.searchParams.set("appId", appId);
  url.searchParams.set("redirectUri", redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("type", "signIn");

  return url.toString();
};
